import ContractInfoModel from "../models/contractInfoPF";
import ContractDetailsModel from "../models/contractsPF";
import PlansByClubModel from "../models/PlansByClub";
import { attInfo, fetchContractDetails, fetchPlansByClub, sendPlanModification } from "../provider/api";
import { cancelContract, fetchContracstPF } from "../provider/enterprise/api_enterprise";

export async function attInfoPF(id: String, cep: String, logradouro: string, numero: string, complemento: string, bairro: string, id_cidade: number, 
    uf: number, email: string, celular: string) {
    try {
        const responseData = await attInfo(id, cep, logradouro, numero, complemento, bairro, id_cidade, uf, email, celular); 
        
        if (responseData.statusCode && (responseData.statusCode !== 200 || responseData.statusCode !== 201)) {
            throw new Error(responseData.message || "Erro ao atualizar cadastro.");
        }
        
        console.log('Deu certo')
        
        return responseData;
        
    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao criar cadastro.`);
        console.log(error.toString());
        return [];
    }
}

export async function getContractsPF(): Promise<{ data: ContractDetailsModel[] | null }> {
    try {
        const cnpj_cpf = localStorage.getItem("cpf_cnpj");
        const responseData = await fetchContracstPF(cnpj_cpf!);

        if (responseData.statusCode && responseData.statusCode !== 200) {
            throw new Error(responseData.message || "Erro ao buscar os dados.");
        }

        let data = ContractDetailsModel.fromApiResponse(responseData);

        if (Array.isArray(data)) {
            data = data.sort((a: any, b: any) => b.numero_contrato - a.numero_contrato);
        }

        return { data };
    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao buscar os dados`);
        console.log(error.toString());
        return { data: null };
    }
}


export async function cancelPlan(contract_id: number, reason: number, description: string) {
    try {
        const responseData = await cancelContract(contract_id, reason, description); 
        
        // if (responseData.statusCode && (responseData.statusCode !== 200 || responseData.statusCode !== 201 || responseData.statusCode !== 202)) {
        //     throw new Error(responseData.message || "Erro ao cancelar plano.");
        // }
        
        console.log('Deu certo')
        
        return responseData;
        
    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao cancelar plano.`);
        console.log(error.toString());
        return [];
    }
}

export async function getContractsDetails(contractId: string): Promise<{ data: ContractInfoModel | null }> {
    try {
        const responseData = await fetchContractDetails(contractId);

        if (responseData.statusCode && responseData.statusCode !== 200) {
            throw new Error(responseData.message || "Erro ao buscar os dados.");
        }

        const data = ContractInfoModel.fromApiResponse(responseData);

        return { data };
    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao buscar os dados`);
        console.log(error.toString());
        return { data: null };
    }
}

export async function getPlansByClub(clubId: string): Promise<{ data: PlansByClubModel[] | null }> {
    try {
        const responseData = await fetchPlansByClub(clubId);

        if (responseData.statusCode && responseData.statusCode !== 200) {
            throw new Error(responseData.message || "Erro ao buscar os dados das categorias.");
        }

        const data = Array.isArray(responseData)
            ? responseData.map((item: any) => PlansByClubModel.fromApiResponse(item))
            : [];

        return { data };
    } catch (error: any) {
        console.error(`Erro (${error.response?.status || "sem status"}) ao buscar categorias`);
        console.log(error.toString());
        return { data: null };
    }
}

interface Dependent{
    nome: string;
    cpf: string;
    telefone: string;
    email: string;
    id_contrato: number;
    grau_parentesco: number;
}

export async function sendChangePlanNotification(contract_id: number, categoryId?: number, agreementId?: number, dependents: Dependent[] = []) {
    try {
        const responseData = await sendPlanModification(contract_id, categoryId, agreementId, dependents); 
        
        // if (responseData.statusCode && (responseData.statusCode !== 200 || responseData.statusCode !== 201 || responseData.statusCode !== 202)) {
        //     throw new Error(responseData.message || "Erro ao cancelar plano.");
        // }
        
        console.log('Deu certo')
        
        return true;
        
    } catch (error: any) {
        console.error(`Erro (${error.response?.status}) ao modificar plano.`);
        console.log(error.toString());
        return [];
    }
}